import { useMutation } from "react-query";
import {
  apiUpdateContractEmployeeValuation,
  TUpdateContractEmployeeValuationRequest,
} from "../../../../../api/contract/apiUpdateContractEmployeeValuation";
import { MutationConfig, queryClient } from "../../../../../lib/react-query";
import { contractKeys } from "../util/contract.query-keys";

type TUpdateContractEmployeeValuation =
  TUpdateContractEmployeeValuationRequest & { contractId: string };

export const updateContractEmployeeValuation = ({
  contractId,
  ...payload
}: TUpdateContractEmployeeValuation) => {
  return apiUpdateContractEmployeeValuation(contractId, payload);
};

type TUseUpdateContractEmployeeValuation = {
  config?: MutationConfig<typeof updateContractEmployeeValuation>;
};

export const useUpdateContractEmployeeValuation = ({
  config,
}: TUseUpdateContractEmployeeValuation = {}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries(contractKeys.all);
    },
    ...config,
    mutationFn: updateContractEmployeeValuation,
  });
};
